// extracted by mini-css-extract-plugin
module.exports = {"section":"Alllist_section__1HxUw","left":"Alllist_left__2cM3u","right":"Alllist_right__1a68u"};